import { Container, Grid, Paper, Text, Title, ThemeIcon, Group, ActionIcon, Button, Skeleton } from "@mantine/core";
import Topnavbar from "../../Layouts/Topnavbar";
import {
    IconCreditCard,
    IconDeviceMobile,
    IconBuildingBank,
    IconArrowsExchange,
    IconReceipt2,
    IconIdBadge, IconAlertTriangle
} from "@tabler/icons-react";
import { useEffect, useState } from "react";
import { IconArrowRight } from "@tabler/icons-react";
import Marquee from 'react-fast-marquee';
import { Alert, message } from "antd";
import { Get_Portal_Updates, Get_User_Details } from "../../apicall";
import { Userauthcontexthooks } from "../../Hooks/Userauthcontexthooks";
import { useNavigate } from 'react-router-dom';


const services = [
    {
        title: "Payment",
        subtitle: "Instant Transfer",
        icon: IconCreditCard,
        color: "#4F46E5",
        link: '/service/payment-transfer'
    },
    {
        title: "Recharge",
        subtitle: "Mobile & DTH",
        icon: IconDeviceMobile,
        color: "#10B981",
    },
    {
        title: "AEPS",
        subtitle: "Cash Withdrawal",
        icon: IconBuildingBank,
        color: "#F59E0B",
    },

    {
        title: "BBPS",
        subtitle: "Bill Payments",
        icon: IconReceipt2,
        color: "#0EA5E9",
    },
    {
        title: "Ticket Booking",
        subtitle: "Flight/Bus/Train",
        icon: IconArrowsExchange,
        color: "#EF4444",
    },
    // {
    //     title: "Wallet",
    //     subtitle: "Fund Transfer",
    //     icon: IconWallet,
    //     color: "#8B5CF6",
    // },
    {
        title: "Bank Verification",
        subtitle: "Penny Drop",
        icon: IconIdBadge,
        color: "#EC4899",
    },
];

const Home = ({ Headername }) => {
    const { user } = Userauthcontexthooks();
    const Navigate = useNavigate();
    const [userLoading, setUserloading] = useState(true);
    const [userData, setUserdata] = useState('');
    const [fetchedPublishedloading, setfetchedPublishloading] = useState(true);
    const [announcement, setAnnouncement] = useState({
        title: "",
        description: "",
    });
    function accountSettings_redirect() {
        Navigate('/user-account-settings')
    }

    useEffect(() => {
        const Get_user_profile = async () => {
            try {
                //setUserloading(false);
                const data = await Get_User_Details();
                if (data.success) {
                    // console.log(data);
                    setUserdata(data?.user);
                }
                // console.log(data);
            } catch (error) {
                console.log(error);
                message.error(
                    error.response?.data?.message ||
                    "Something went wrong."
                );

            } finally {
                setUserloading(false);
            }
        }
        // const Get_user_wallet = async () => {
        //     try {
        //         const data = await Get_User_Wallet_Details();
        //         if (data.success) {
        //             // console.log(data);
        //             setUserwallet(data?.Userwallet);
        //             //setUserwalletloading(false);
        //         }
        //         // console.log(data);
        //     } catch (error) {
        //         console.log(error);
        //         message.error(
        //             error.response?.data?.message ||
        //             "Something went wrong."
        //         );

        //     } finally {
        //         setUserwalletloading(false);
        //     }
        // }

        if (user) {
            Get_user_profile();
            // Get_user_wallet();
        }
    }, [user])
    useEffect(() => {
        const fetchPublishupdates = async () => {
            try {
                const data = await Get_Portal_Updates();
                if (data.success) {
                    // console.log(data);
                    setAnnouncement({
                        title: data?.LatestUpdates?.UpdateTitle,
                        description: data?.LatestUpdates?.UpdateDiscription,
                    });
                }
            } catch (error) {
                console.log(error);
                message.error(
                    error.response?.data?.message ||
                    "Something went wrong."
                );
            } finally {
                setfetchedPublishloading(false);
            }
        }

        if (user) {
            fetchPublishupdates();
        }

    }, [user])
    return (
        <>
            <Topnavbar Headername={Headername} />
            <Skeleton visible={fetchedPublishedloading}>
                <Alert
                    banner
                    title={
                        <Marquee pauseOnHover gradient={false}>
                            {announcement?.title || "Announcement title"}
                        </Marquee>
                    }
                    description={
                        announcement?.description && (
                            <Marquee pauseOnHover gradient={false}>
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: announcement?.description,
                                    }}
                                />
                            </Marquee>
                        )
                    }

                    showIcon={false}
                />
            </Skeleton>
            {(!userData?.ispasswordchanged || !userData?.ismpinchanged) && (
                <Skeleton visible={userLoading}   >
                    <Alert
                        type=""
                        showIcon
                        icon={<IconAlertTriangle />}
                        title="Security Action Required"
                        description={
                            <div>
                                <div style={{ marginBottom: 12 }}>
                                    Please change your{" "}
                                    {!userData?.ispasswordchanged && <b>Password</b>}
                                    {!userData?.ispasswordchanged &&
                                        !userData?.ismpinchanged &&
                                        " and "}
                                    {!userData?.ismpinchanged && <b>MPIN</b>}
                                    {" "}before using the portal. Your account currently has the default credentials assigned during registration.
                                </div>

                                <Button
                                    type="primary"
                                    size="small"
                                    onClick={accountSettings_redirect}
                                >
                                    Change Now
                                </Button>
                            </div>
                        }
                        closable
                        style={{ borderRadius: 'none', border: 'none', }}

                    />
                </Skeleton>
            )}

            <Container size={'xl'} mt={'lg'} >
                <Title c={'dimmed'}>Welcome to the Retailer Portal</Title>
                <Text size="xs">This is the home page of the retailer dashboard. Here you can find an overview of your account, recent transactions, and quick links to important features.</Text>
            </Container >
            <Container size="lg" mt="lg" mb={'sm'}>
                <Title order={3} mb={'xs'} c={'blue'}>Services:</Title>
                <Grid justify="center">
                    {services.map((service, index) => (
                        <Grid.Col
                            key={index}
                            span={{ xs: 12, sm: 6, md: 4, lg: 3, xl: 2.4 }}
                        >
                            <Paper
                                radius="xs"
                                p="lg"
                                shadow="sm"
                                withBorder
                                style={{
                                    cursor: "pointer",
                                    transition: "all .25s ease",
                                    height: 150,
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = "translateY(-6px)";
                                    e.currentTarget.style.boxShadow =
                                        "0 12px 24px rgba(0,0,0,.12)";
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = "translateY(0)";
                                    e.currentTarget.style.boxShadow = "";
                                }}

                                onClick={()=> window.location.href = service?.link}
                            >
                                <Group justify="space-between">
                                    <ThemeIcon
                                        radius="xl"
                                        size={54}
                                        color={service.color}
                                        variant="light"
                                    >
                                        <service.icon size={28} />
                                    </ThemeIcon>

                                    <ActionIcon
                                        radius="xl"
                                        variant="light"
                                        color={service.color}
                                    >
                                        <IconArrowRight size={18} />
                                    </ActionIcon>
                                </Group>

                                <Text fw={700} mt="lg" size="lg">
                                    {service.title}
                                </Text>

                                <Text c="dimmed" size="xs" mt={2}>
                                    {service.subtitle}
                                </Text>
                            </Paper>
                        </Grid.Col>
                    ))}
                </Grid>
            </Container>
        </>
    )
}
export default Home;